<template>
  <div :id="`ks-map-${_uid}`">
  </div>
</template>


<script>
import checkPermissions from '../../mixins/checkPermissions';
import {Loader} from '@googlemaps/js-api-loader';

export default {
  /**
   tag
   name: ks-map
   description: map
   **/
  name:   "ks-map",
  mixins: [checkPermissions],
  props:  {
    data_provider:     {type: String},
    readFilters:       {
      type: Object, default: () => {
      }
    },
    clickRecordFields: {
      type: Array, default: () => []
    },
    zoom:              {
      type:    Number,
      default: 4
    },
    center:            {
      default: () => {
        return {lat: 39.774769485295465, lng: -100.17817356925106}
      }
    },
    mapType:           {
      type:    String,
      default: "terrain" //'satellite','terrain'
    },
    options:           {
      type:    Object,
      default: () => ({})
    },
    markers:           {
      type:    Array,
      default: () => ([])
    },
    routes:            {
      type:    Array,
      default: () => ([])
    },
    apiKey:            {
      type:     String,
      required: true
    },
  },
  watch:  {
    markers: function (val) {
      if (window.google) {
        this.removeMarkers();
        this.loadMarkers();
      }
    },
    center:  function (val) {
      this.setCenter(val);
    },
    zoom:    function (val) {
      this.setZoom(val)
    }
  },
  mounted() {
    let loader = new Loader({
      apiKey: this.apiKey
    })
    loader.load()
        .then(() => {
          this.map = new google.maps.Map(document.getElementById(`ks-map-${this._uid}`), {
            fullscreenControl:     true,
            scaleControl:          true,
            streetViewControl:     true,
            mapTypeControl:        true,
            mapTypeControlOptions: {
              style:    google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
              position: google.maps.ControlPosition.TOP_CENTER,
            },
            zoomControl:           true,
            zoomControlOptions:    {
              position: google.maps.ControlPosition.LEFT_TOP,
            },
            zoom:                  this.zoom,
            center:                this.center,
            mapTypeId:             this.mapType,
            ...this.options,
          });

          // add the click listener.
          this.map.addListener("click", (mapsMouseEvent) => {
            this.$emit('click', mapsMouseEvent);
          });
          // add the zoom listener
          this.map.addListener('zoom_changed', () => {
            this.$emit('zoom', this);
          });
          // add drag listener
          this.map.addListener('dragend', () => {
            this.$emit('dragend', this);
          });

          this.loadMarkers();
          this.$emit('onLoad', this);
        })
        .catch(err => {
          console.log('KS-APP: ', err);
          this.$emit('onError', err);
        });
  },
  methods: {
    getBounds() {
      let bounds = this.map.getBounds();
      return [{lat: bounds.getNorthEast().lat(), lng: bounds.getNorthEast().lng()}, {
        lat: bounds.getSouthWest().lat(),
        lng: bounds.getSouthWest().lng()
      }]
    },
    setZoom(val) {
      this.map.setZoom(val);
    },
    setCenter(center) {
      if (center && typeof center.lat !== 'undefined' && typeof center.lng !== 'undefined') {
        this.map.setCenter(center);
      }
    },
    removeMarkers() {
      for (let marker of this.mapMarkers) {
        marker.setMap(null);
      }
      this.mapMarkers = [];
    },
    removeMarker(markerId) {
      let index = this.markers.findIndex(m => m.id == markerId);
      if (index > -1) {
        this.mapMarkers[index].setMap(null);
        this.mapMarkers.splice(index, 1);
      }
    },
    loadMarkers() {
      if (this.markers.length > 0) {
        this.markers.forEach(m => this.addMarker(m));
      }
    },
    autoCenter() {
      if (this.markersBounds !== null) {
        this.map.fitBounds(this.markersBounds);
      }
    },
    addMarker(m) {
      try {
        if (m.latitude || m.lat && m.longitude || m.lng) {
          this.markersBounds = new google.maps.LatLngBounds();
          let latLng         = new google.maps.LatLng(m.latitude || m.lat, m.longitude || m.lng);
          let marker         = new google.maps.Marker({
            ...m,
            map:      this.map,
            position: latLng,
          });
          if (m.click) {
            if (typeof m.click == 'function') {
              marker.addListener("click", m.click);
            } else {
              marker.addListener("click", async (evt) => {
                if (this.infowindow) this.infowindow.close();
                let dp     = app.getDataprovider(this.data_provider);
                let res    = await dp.readRecord(m.campaign_id, m.id, false, this.readFilters);
                let record = dp.getLocalRecord();
                let clickVal = `${m.click}${this.clickRecordFields.length > 0 ? "<br>" : ""}`
                this.clickRecordFields.forEach(field => {
                      if (record[field.field]) {
                        clickVal += `${record[field.field]}${field.brAfter ? "<br>" : " "}`
                      }
                    }
                )
                this.infowindow = new google.maps.InfoWindow({
                  content: clickVal,
                  id:      marker.id
                });
                this.infowindow.open(this.map, marker);
                this.$emit('markerClick', evt);
              });
            }
          }
          this.mapMarkers.push(marker);
          this.markersBounds.extend(marker.position);
        }
      } catch (err) {
        console.log('KS-APP: ', err);
      }
    },
  },
  data() {
    return {
      map:           null,
      mapMarkers:    [],
      infowindow:    null,
      markersBounds: null
    }
  }
}
</script>